// src/hooks/useFormSubmit.js
import { useState } from "react";
import axios from "axios";



const baseUrl = process.env.REACT_APP_API_URL_REACT;
export const CONTENT_BASE = process.env.REACT_APP_CONTENT_URL || "https://gestione.carellidistribuzione.it/contenuti";



export default function useFormSubmit(apiEndpoint, task) {
  // Stati locali
  const [formData, setFormData]     = useState({});
  const [sending, setSending]       = useState(false);
  const [resultMessage, setResult]  = useState(null);

  // Al change di ogni campo
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Al submit del form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);

    try {
      // Task + formData → payload
      const payload = { task, ...formData };
      await axios.post(apiEndpoint, payload);
      setResult({ type: "success", text: "Messaggio inviato con successo!" });
    } catch (err) {
      setResult({ type: "error", text: "Errore durante l’invio. Riprova." });
    } finally {
      setSending(false);
    }
  };

  return {
    formData,
    sending,
    resultMessage,
    handleChange,
    handleSubmit,
  };
}


export async function postVendita(ID) {
  const url = `${baseUrl}estrazioni-pv`;
  const form = new FormData();
  form.append("pv", ID);
  form.append("task", 'estrazioni_pv');
  try {
    const res = await axios.post(url, form);
    return res.data.data || [];
  } catch (err) {
    // Se c’è un errore HTTP, axios lo mette in err.response
    console.error("[postVendita] ERROR", err.response?.status, err.response?.data || err);
    throw err;
  }
}


export async function postComuniOfferte(ID) {
  const url = `${baseUrl}offerte-pv-comuni`;
  const form = new FormData();
  form.append("citta", ID);
  form.append("task", 'offerte_pv_comuni');
  try {
    const res = await axios.post(url, form);
    return res.data.data || [];
  } catch (err) {
    // Se c’è un errore HTTP, axios lo mette in err.response
    throw err;
  }
}

export async function postOfferte(ID) {
  const url = `${baseUrl}offerte-pv-comuni`;
  const form = new FormData();
  form.append("punto_vendita", ID);
  form.append("task", 'offerte_attive');
  try {
    const res = await axios.post(url, form);
    return res.data.data || [];
  } catch (err) {
    // Se c’è un errore HTTP, axios lo mette in err.response
    throw err;
  }
}


//restituisce tutti i punti vendita di dato comune
export async function postPuntiVedndita(ID) {

  const url = `${baseUrl}pv-list`;
  const form = new FormData();
  form.append("citta", ID);
  form.append("task", 'lista_pv');

  try {
    const res = await axios.post(url, form);
    return res.data.data || [];
  } catch (err) {
    // Se c’è un errore HTTP, axios lo mette in err.response
    throw err;
  }
}

